const AppointmentsConstants = {
    booking_type: {
        ONLINE: 0,
        WALK_IN: 2,
        CALL_IN: 3
    }
};

export { AppointmentsConstants };
